import { Subject } from 'rxjs';

export const STAGE_MAP = {
  'beta.rosetta.amazon.dev': 'beta',
  'beta.app.luma.wwcs.amazon.dev': 'beta',
  localhost: 'local',
  'gamma.rosetta.amazon.dev': 'gamma',
  'gamma.app.luma.wwcs.amazon.dev': 'gamma',
  'prod.rosetta.amazon.dev': 'prod',
  'prod.app.luma.wwcs.amazon.dev': 'prod',
  'rosetta.amazon.dev': 'prod',
};

export const STAGE = STAGE_MAP[window.location.hostname];

const DOMAIN_BASE = window.location.hostname.includes('luma.wwcs.amazon.dev')
  ? 'app.luma.wwcs.amazon.dev'
  : 'rosetta.amazon.dev';

let apiHost = `https://api.${STAGE}.rosetta.amazon.dev/`;
let siteHost = `https://${STAGE}.${DOMAIN_BASE}/`;

if (process.env.NODE_ENV !== 'production') {
  apiHost = 'http://localhost:3000/';
  siteHost = 'http://localhost:3000';
}

export const API_HOST = apiHost;
export const SITE_HOST = siteHost;

export const REQUEST_MODE = 'cors';

export const statusMessage$ = new Subject({});

export const GENERAL_ACCESS = 'rts_tsi_general_access';
export const CONTACT_LOOKUP_ACCESS = 'rts_tsi_contact_lookup_access';
export const USER_MANAGER_ACCESS = 'rts_tsi_user_manager_access';
export const WORKFLOW_ACCESS = 'rts_tsi_workflow_access';
export const RESOURCES_ACCESS = 'rts_tsi_resources_access';
export const INTERNAL_ACCESS = 'rts_tsi_internal_only_access';
export const WORKFLOW_EDIT_ACCESS = 'rts_tsi_workflow_edit_access';
export const RTS_ADMINS_GROUP = 'RTS_ADMINS';

// Month, hours, minutes, seconds, and ms all are 0-indexed
// Year is actual year, day of month is actual date
// Month: 0=January, 11=December
export const RESTRICTED_DAYS_START = new Date(Date.UTC(2023, 10, 17, 8, 0, 0, 0));
export const RESTRICTED_DAYS_END = new Date(Date.UTC(2023, 10, 30, 3, 59, 59, 999));

export const COGNITO_PERMISSION_TO_ACCESS = new Map([
  [
    'TenantWorkflowManager',
    [GENERAL_ACCESS, CONTACT_LOOKUP_ACCESS, WORKFLOW_ACCESS, WORKFLOW_EDIT_ACCESS, RESOURCES_ACCESS],
  ],
  ['UserManager', [GENERAL_ACCESS, CONTACT_LOOKUP_ACCESS, USER_MANAGER_ACCESS]],
  [
    'TenantAdmin',
    [
      GENERAL_ACCESS,
      CONTACT_LOOKUP_ACCESS,
      WORKFLOW_EDIT_ACCESS,
      USER_MANAGER_ACCESS,
      WORKFLOW_ACCESS,
      RESOURCES_ACCESS,
    ],
  ],
  ['TenantUser', [GENERAL_ACCESS, CONTACT_LOOKUP_ACCESS, WORKFLOW_ACCESS, RESOURCES_ACCESS]],
  [
    RTS_ADMINS_GROUP,
    [
      GENERAL_ACCESS,
      CONTACT_LOOKUP_ACCESS,
      RESOURCES_ACCESS,
      USER_MANAGER_ACCESS,
      WORKFLOW_EDIT_ACCESS,
      WORKFLOW_ACCESS,
      INTERNAL_ACCESS,
    ],
  ],
]);

export const setGlobalSuccessMessage = message => {
  statusMessage$.next({
    type: 'success',
    message: message,
  });
};

export const setGlobalErrorMessage = message => {
  statusMessage$.next({
    type: 'error',
    message: message,
  });
};

export const clearGlobalMessage = () => {
  statusMessage$.next();
};
